import {
  EXCHANGE_SET_NEW_ITEM_ASIN,
  EXCHANGE_SET_PRODUCT_BUNDLE_INFO,
  EXCHANGE_SET_PROVIDE_LABEL_OPTION,
  EXCHANGE_STEP_SELECTION,
  EXCHANGE_SUBMIT_COMPLETE,
  EXCHANGE_SUBMIT_ERROR,
  EXCHANGE_SUBMIT_INITIATE,
  RECEIVE_POST_EXCHANGE_INFO,
  RECEIVE_PRE_EXCHANGE_INFO
} from 'constants/reduxActions';
import { PROVIDE_LABEL_OPTIONS } from 'constants/exchanges';

const initialState = {
  preExchangeInfo: {},
  postExchangeInfo: {},
  isExchangeSubmitting: false,
  labelInfo: {},
  isExchangeError: false,
  productBundleResponse: {},
  asinSelectedForExchange: null,
  displayLabelMod: PROVIDE_LABEL_OPTIONS.PRINT
};

export default function exchange(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_PRE_EXCHANGE_INFO :
      return {
        ...state,
        preExchangeInfo: action.payload
      };
    case EXCHANGE_SUBMIT_INITIATE :
      return {
        ...state,
        isExchangeSubmitting: true,
        isExchangeError: false
      };
    case EXCHANGE_SUBMIT_ERROR :
      return {
        ...state,
        isExchangeSubmitting: false,
        isExchangeError: true
      };
    case EXCHANGE_SUBMIT_COMPLETE :
      return {
        ...state,
        isExchangeSubmitting: false,
        isExchangeError: false
      };
    case RECEIVE_POST_EXCHANGE_INFO :
      return {
        ...state,
        postExchangeInfo: action.payload
      };
    case EXCHANGE_STEP_SELECTION :
      return {
        ...state,
        step: action.payload
      };
    case EXCHANGE_SET_NEW_ITEM_ASIN :
      return {
        ...state,
        asinSelectedForExchange: action.payload
      };
    case EXCHANGE_SET_PRODUCT_BUNDLE_INFO :
      return {
        ...state,
        productBundleResponse: action.payload
      };
    case EXCHANGE_SET_PROVIDE_LABEL_OPTION :
      return {
        ...state,
        displayLabelMod: action.payload
      };
    default:
      return state;
  }
}
